import {
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from 'vue-router';
const { ROUTER_BASEURL } = require('../../src/config');
//单个引入2个方式
// component: () => import(/* webpackChunkName: "about" */ "../views/About.vue")
// import Home from "../views/Home.vue";

// 项目其他页面路由（推荐使用）
import mountains from './mountains/mountains';

// vue项目自带路由
const routes = [
  //非项目router
];

// const routers = [...routes, ...mountains];

const router = createRouter({
  // history: createWebHashHistory, hash模式
  history: createWebHistory(ROUTER_BASEURL),
  routes: [...routes, ...mountains],
});

const whiteList = [
  '/wap',
  '/pay',
  '/vipPay',
  '/account-detail',
  '/show',
  '/enterpriseIdentityAuthentication',
];

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    // 判断是否有标题
    document.title = to.meta.title;
  }
  if (
    typeof window !== 'undefined' &&
    typeof window.navigator !== 'undefined'
  ) {
    if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      console.log('navigator.userAgent', navigator.userAgent);
      //处理移动端的业务逻辑
      if (whiteList.some((curr) => to.path.startsWith(curr))) {
        console.log(
          'whiteList',
          whiteList.some((curr) => to.path.startsWith(curr))
        );
        next();
      } else {
        // console.log(
        //   'whiteList---else',
        //   whiteList.some((curr) => to.path.startsWith(curr))
        // );
        // to.path = to.path + 'wap';
        // next(to.path);
      }
    } else {
      console.log('pc------log');
      //处理电脑端的业务逻辑
      if (to.path.indexOf('/wap') > -1) {
        let path = to.path.replace('/wap', '');
        next(path);
      } else {
        next();
      }
    }
  }
});
// 配置base属性 声明路由根目录

export default router;
